<template>
  <div class>
    <!--=== Header Start ===-->
    <header v-show="false" class="header-navbar sticky-top">
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-md-12 px-0 py-0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="left-logo edu-banner">
                <a href>
                  <img id="imgBanner" v-bind:src="BannerURL" />
                </a>
              </div>
            </div>
            <div class="sstop-btn-hld">
              <ul>
                <li><a href="#">Get Help</a></li>
                <li>
                  <a
                    href="javascript:void(0)"
                    class="btn"
                    style="background: #dbdbdb"
                    >Event Hub</a
                  >
                </li>
                <li v-if="ShowCreateEventButton">
                  <button class="btn btn-primary" @click="createEvent">
                    Create Event
                  </button>
                  <!-- <button class="btn btn-primary" data-toggle="modal" data-target="#crete_eventModalCenter">
                    Create Event
                  </button> -->
                </li>
                <li v-if="ShowSignInPopup && !hasSession">
                  <a href="javascript:void(0)" @click="DisplaySignInPopup"
                    >Sign In</a
                  >
                </li>
                <li v-else-if="!hasSession">
                  <router-link to="/">Sign In</router-link>
                </li>
                <li v-else class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      src="../assets/Images/attendee.png"
                      width="40"
                      height="40"
                      class="rounded-circle"
                    />
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink"
                    style="right: 0 !important"
                  >
                    <router-link class="dropdown-item" to="/eventoverview"
                      >Dashboard</router-link
                    >
                    <a class="dropdown-item" href="javascript:void(0)"
                      >Edit Profile</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click="Logout"
                      >Log Out</a
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div
      class="
        page-effect
        RegEvent-wrapper
        edu-rage
        event_list_reg
        events_listtemplate_one
      "
    >
     
      <section class="event-box-list-wrapper">
         <!-----filter-area-->
          <div class="ev-filt-wrap">
            <div class="container-fluid">
            <div class="row my-0">
              <div class="col">
                <div class="form-group">
                  <!-- <label class="popup-label">Event Name</label> -->
                  <input
                    type="text"
                    class="form-control se-ev"
                    placeholder="Search events"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control date-bg"
                    placeholder="Select from date"
                    v-model="filterDateFrom"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control date-bg"
                    placeholder="Select to date"
                    :min="filterDateFrom"
                    v-model="filterDateTo"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <!-- {{ regions }} -->
                  <select class="form-control" v-model="filterRegion">
                    <!-- <option>--Region--</option>
                    <option>Region1</option>
                    <option>Region2</option> -->
					<option>--Region--</option>
                    <option
                      v-for="(item, index) in regions"
                      :key="index"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <select class="form-control" v-model="filterType">
                    <option value="">--Topic--</option>
                    <option value="">All</option>
                    <option value="free">Free</option>
                    <option value="paid">Paid</option>
                  </select>
                </div>
              </div>
              <div class="col d-none">
                <div class="form-group">
                  <label class="popup-label">Topic</label>
                  <select class="form-control">
                    <option>Select Topic</option>
                    <option>Topic1</option>
                    <option>Topic</option>
                  </select>
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <button
                    :class="
                      advancedSearch
                        ? 'btn btn-primary btn-ev-se cl-filter'
                        : 'btn btn-primary btn-ev-se'
                    "
                    @click="ClearFilter"
                  >
                    {{ SearchButtonText }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          </div>
          <!-----filter-area end-->
          <!---event list body start--->
          <div class="event_body_container">
        <div class="container-fluid px-3">
          <div class="row my-0 ">
            <div
              class="no-reg-events"
              v-if="EventsLoaded && RecentEvents.length == 0"
            >
              <h3>There are currently no events to Register.</h3>
            </div>
            <div class="events--pale-tan full-width">
            <!-----tab area--->
            <div class="cust-container">
            <div class="col-md-12 pt-0">
               
              <h2 class="ev_head mt-6">Live/Upcoming Events</h2>
			<p class="heading__description">All the virtual and in-person events coming up across core conferences and strategic solutions, gathering leading minds in politics, finance and business with senior FT journalists to discuss the big issues of our time.</p>
             </div>
            </div>
            <!-----tab area end--->
            <div class="tab-content px-3">
              <div class="tab-pane in active">
                <div class="row">
                  <!-- v-on:click="selectEvent(events.id, events.Name)" -->
                  <div
                    v-for="events in FilteredRecentEvents"
                    v-bind:key="events.id"
                    v-bind:id="events.id"
                    class="col-md-4 event_list_box_w pb-0"
                  >
                    <!--add calender dropdown start-->
                    <div
                      v-if="EnableAddToCalender"
                      class="dropdown ss-add-cal-dp"
                    >
                      <button
                        class="btn trans-add-cal"
                        type="button"
                        data-toggle="dropdown"
                      ></button>
                      <div class="dropdown-menu">
                        <a
                          class="dropdown-item"
                          :href="AddToGoogleCalendar(events)"
                          target="_blank"
                          >Google</a
                        >
                        <a
                          class="dropdown-item"
                          :href="AddToCalendar(events, 'apple')"
                          target="_blank"
                          >Apple</a
                        >
                        <a
                          class="dropdown-item"
                          :href="AddToCalendar(events, 'yahoo')"
                          target="_blank"
                          >Yahoo</a
                        >
                        <a
                          class="dropdown-item"
                          :href="AddToCalendar(events, 'outlook')"
                          target="_blank"
                          >Outlook</a
                        >
                        <a
                          class="dropdown-item"
                          :href="AddToCalendar(events, 'stream')"
                          target="_blank"
                          >Download</a
                        >
                      </div>
                    </div>
                    <!--add calender dropdown end-->
                    <div
                      class="ev-box event-list-register-shimmer"
                      @click="selectEvent(events.id, events.Name)"
                    >
                      <div class="ev-box-image-hld">
                        <div class="shimmer-effect">
                          <photo class="shine"></photo>
                        </div>
                        <div class="evb-hld">
                          <img
                            v-bind:src="events.EventLogo"
                            v-bind:alt="events.Name"
                            v-on:load="stopShimmer()"
                          />
                        </div>
						<div class="top-right-login">
                          <a href class="time-sch"
                            >{{ events.EventStartDateString }} to
                            {{ events.EventEndDateString }} &nbsp;
                            {{ events.EventTimezone }}</a
                          >
                        </div>
                        <h4 class="p-0">{{ events.Name }}</h4>
                      </div>
                      
                    </div>
                  </div>
                  <div
                    v-if="EventsLoaded && FilteredRecentEvents.length == 0"
                    class="text-center p-4"
                  >
                    <h2 class="text-center">
                      No matches found for your Search
                    </h2>
                  </div>
                </div>
            <div class="show_more_btnwrap text-center">
			<button type="button" class="btn btn-outline-primary">Show more</button>
			</div>
			</div>
              <!--Today end-->
              <!----->
              <!-- <div id="week" class="tab-pane fade">week</div> -->
              <!----->
              <!----->
              <!-- <div id="month" class="tab-pane fade">month</div> -->
              <!----->
            </div>
          </div>
            
            <!---most populer start----->
             <!--event section end-->
            <div class="events--pale-tan events--pale-grey full-width">
            <!-----tab area--->
            <div class="cust-container">
            <div class="col-md-12 py-0">
              <h2 class="ev_head my-6">Past Events</h2>
            </div>
             </div>
            <!-----tab area end--->
            <div class="tab-content px-3">
              <div class="tab-pane in active">
                <div class="row">
                  <div
                    v-for="events in PastEvents"
                    v-bind:key="events.id"
                    v-on:click="selectEvent(events.id, events.Name)"
                    v-bind:id="events.id"
                    class="col-md-4 event_list_box_w pb-0"
                  >
                    <div class="ev-box event-list-register-shimmer">
                      <div class="ev-box-image-hld">
                        <div class="shimmer-effect">
                          <photo class="shine"></photo>
                        </div>
                        <div class="evb-hld">
                          <img
                            v-bind:src="events.EventLogo"
                            v-bind:alt="events.Name"
                            v-on:load="stopShimmer()"
                          />
                        </div>
						<div class="top-right-login">
                          <a href class="time-sch ">
                            {{ events.IsPublished }}
                            {{ events.EventStartDateString }} to
                            {{ events.EventEndDateString }} &nbsp;
                            {{ events.EventTimezone }}
                          </a>
                        </div>
                        <h4 class="p-0">{{ events.Name }}</h4>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <!--Today end-->
              <!----->
              <!-- <div id="Paid" class="tab-pane fade">Paid</div> -->
              <!----->
            </div>
            <!---most populer end----->
            </div>
            <!--event section end-->
          </div>
        </div>
         </div>
      </section>
    </div>

    <!-- Admin Login Modal -->
  </div>
</template>
<script>
// import Router from "vue-router";
// import firebase from "firebase";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
// import firebase from "firebase";
// import axios from "axios";
// import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;

var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
import common from "@/common";
Vue.use(VueMoment, {
  moment,
});

var timer;
export default {
  data() {
    return {
      uid: "",
      noEventLink: "https://e2m.live/",
      EventsLoaded: false,
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      searchText: "",
      EnableEventFilter: false,
      EnableAddToCalender: false,
      ShowCreateEventButton: false,
      ShowSignInPopup: false,
      advancedSearch: false,
      filterDateFrom: "",
      filterDateTo: "",
      filterRegion: "",
      filterType: "",
      RecentFilterTab: "today",
      startDate: "",
      endDate: "",
      regions: [],
      firstName: "",
      lastName: "",
      emailId: "",
      systemTimeDiff: 0,
      currentTimeS: parseInt(new Date().getTime() / 1000),
      
      showVerificationLinkSentMessage: false,
      IsSubmitting: false,
      AddToCalendarList: [
        { Name: "Google", Service: "google" },
        { Name: "Apple", Service: "apple" },
        { Name: "Yahoo", Service: "yahoo" },
        { Name: "Outlook", Service: "outlook" },
        { Name: "Download", Service: "stream" },
      ],
    };
  },
  computed: {
    hasSession() {
      if (self.uid) {
        return true;
      } else {
        return false;
      }
    },
    RecentEvents() {
      var result = [];
      result = self.EventsData.filter(function (item) {
        if (self.currentTimeS < item.EventEndDate.seconds) {
          return true;
        }
      });
      return result;
    },
    PastEvents() {
      var result = [];
      result = self.EventsData.filter(function (item) {
        if (self.currentTimeS >= item.EventEndDate.seconds) {
          return true;
        }
      });
      result = result.sort(function compare(a, b) {
        return b.EventStartDate.seconds - a.EventStartDate.seconds;
      });
      return result;
    },
    FilteredRecentEvents() {
      var result = [];
      var searchText = self.searchText
        ? self.searchText.trim().toLowerCase()
        : "";
      if (!searchText) {
        result = self.RecentEvents.filter(function () {
          return true;
        });
      } else {
        result = self.RecentEvents.filter(function (item) {
          if (item.Name.toLowerCase().includes(searchText.toLowerCase())) {
            return true;
          }
        });
      }
      if (self.filterDateFrom) {
        let filterDateFrom = new Date(self.filterDateFrom);
        let startSeconds = parseInt(filterDateFrom.getTime() / 1000);
        result = result.filter(function (item) {
          if (startSeconds < item.EventEndDate.seconds) {
            return true;
          }
        });
      }
      if (self.filterDateTo) {
        let filterDateTo = new Date(self.filterDateTo);
        filterDateTo.setDate(filterDateTo.getDate() + 1);
        let endSeconds = parseInt(filterDateTo.getTime() / 1000);
        result = result.filter(function (item) {
          if (endSeconds > item.EventEndDate.seconds) {
            return true;
          }
        });
      }
      if (self.filterRegion) {
        result = result.filter(function (item) {
          if (item.Timezone == self.filterRegion) {
            return true;
          }
        });
      }
      if (
        result.length > 0 &&
        !self.advancedSearch &&
        self.RecentFilterTab != ""
      ) {
        let startSeconds = 0;
        let endSeconds = 0;
        let dt = new Date();
        if (self.RecentFilterTab == "today") {
          let startDate = new Date(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate()
          );
          let endDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
          endDate.setDate(endDate.getDate() + 1);
          startSeconds = parseInt(startDate.getTime() / 1000);
          endSeconds = parseInt(endDate.getTime() / 1000);
          //  alert(startDate);
          //  alert(endDate);
          self.startDate = startDate;
          self.endDate = endDate;
        } else if (self.RecentFilterTab == "week") {
          let startDate = new Date(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate()
          );
          //startDate.setDate(startDate.getDate() - dt.getDay());
          let endDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
          endDate.setDate(endDate.getDate() - endDate.getDay() + 7);
          startSeconds = parseInt(startDate.getTime() / 1000);
          endSeconds = parseInt(endDate.getTime() / 1000);
          //alert(new Date().getDay());
          //  alert(startDate);
          //  alert(endDate);
          self.startDate = startDate;
          self.endDate = endDate;
        } else if (self.RecentFilterTab == "month") {
          //let startDate = new Date(dt.getFullYear(), dt.getMonth(), 1);
          let startDate = new Date(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate()
          );
          let endDate = new Date(dt.getFullYear(), dt.getMonth(), 1);
          endDate.setMonth(endDate.getMonth() + 1);
          startSeconds = parseInt(startDate.getTime() / 1000);
          endSeconds = parseInt(endDate.getTime() / 1000);
          //alert(new Date().getDay());
          //  alert(startDate);
          //  alert(endDate);
          self.startDate = startDate;
          self.endDate = endDate;
        }
        result = result.filter(function (item) {
          if (self.RecentFilterTab == "") {
            return true;
          } else {
            if (
              (item.EventStartDate.seconds <= startSeconds &&
                item.EventEndDate.seconds >= endSeconds) ||
              (item.EventStartDate.seconds >= startSeconds &&
                item.EventStartDate.seconds < endSeconds) ||
              (item.EventEndDate.seconds > startSeconds &&
                item.EventEndDate.seconds < endSeconds)
            ) {
              return true;
            }
            // if (
            //   (item.EventStartDate.seconds >= startSeconds &&
            //     item.EventStartDate.seconds < endSeconds) ||
            //   (item.EventEndDate.seconds >= startSeconds &&
            //     item.EventEndDate.seconds < endSeconds)
            // ) {
            //   return true;
            // }
          }
        });
      }
      result = result.sort(function compare(a, b) {
        return a.EventStartDate.seconds - b.EventStartDate.seconds;
        //return b.EventStartDate.seconds - a.EventStartDate.seconds;
      });
      //alert(result.length);
      return result;
    },
    SearchButtonText() {
      var result = "Search";
      self.advancedSearch = false;
      if (
        self.filterDateFrom ||
        self.filterDateTo ||
        self.filterRegion ||
        self.filterType
      ) {
        result = "Clear Filter";
        self.advancedSearch = true;
      }
      return result;
    },
  },
  watch: {
    //searchText(val) {
    //  alert(val);
    //},
    filterDateFrom(val) {
      if (val) {
        self.RecentFilterTab = "";
        if (self.filterDateTo) {
          if (self.filterDateFrom > self.filterDateTo) {
            self.filterDateTo = "";
          }
        }
      }
    },
    filterDateTo(val) {
      if (val) {
        self.RecentFilterTab = "";
      }
    },
  },
  beforeCreate() {
    // setTimeout(() => {
    //   setTimeout(() => {
    //     setTimeout(() => {
    //       $("#app").addClass("full-screen");
    //     }, 100);
    //     $("#app").addClass("full-screen");
    //   }, 100);
    //   $("#app").addClass("full-screen");
    // }, 100);
    // $("#app").addClass("full-screen");
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
  },
  beforeDestroy() {
    if (timer) {
      clearInterval(timer);
    }
  },
  created() {
    self = this;
    self.uid = self.getSessionUserId();
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
    self.createTimer();
  },
  mounted() {
    document.querySelector('meta[name="title"]').setAttribute("content", "this is title meta");
     document.querySelector('meta[name="description"]').setAttribute("content", "this is description");
     
    self.regions = [{ label: "Select Region", value: "" }].concat(
      common.getTimeZones()
    );
    self.noEventLink = self.$t("client.registerRoute");
    self.clientID = self.$route.params.c;

    //this.clientID = self.$route.params.c;
    /* $("#alleventSec").css("background-size", "cover");
    $("#alleventSec").css("background-color", "none");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#alleventSec").css(
      "background-image",
      "url(" + obj.branding[0].bg2 + ")"
    );
    $("#alleventSec").css("background-size", "100%");
    //alert(obj.Branding[0].banner)
    $("#imgBanner").attr("src", obj.branding[0].banner);

    $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);*/
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // this.BannerURL = obj.branding[0].banner;
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    //  self.tid =
    //   this.$route.params.tid == undefined ? "" : this.$route.params.tid;

    //-------------------------GEt client id by host---------------------------------------
    //self.clientID = this.$route.params.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    //console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        document.title = res.data.ClientName;
        if (
          res.data.clientSettings &&
          res.data.clientSettings.EnableEventFilter
        ) {
          self.EnableEventFilter = res.data.clientSettings.EnableEventFilter;
        }
        if (res.data.clientSettings && res.data.clientSettings.AddToCalender) {
          self.EnableAddToCalender = res.data.clientSettings.AddToCalender;
        }
        if (
          res.data.clientSettings &&
          res.data.clientSettings.ShowCreateEventButton
        ) {
          self.ShowCreateEventButton =
            res.data.clientSettings.ShowCreateEventButton;
        }
        if (
          res.data.clientSettings &&
          res.data.clientSettings.ShowSignInPopup
        ) {
          //self.ShowSignInPopup = res.data.clientSettings.ShowSignInPopup;
        }
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner2048x88
        ) {
          self.desktopBanner = res.data.EventListAssets.banner2048x88;
        }
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner750x103
        ) {
          self.mobileBanner = res.data.EventListAssets.banner750x103;
        }
        self.initScreen();
        self.EventsData = [];
        if(self.clientID){
          self.displayEvents();
        }
        
      });
  },
  methods: {
    createEvent() {
      debugger;
      var headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      var requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: "C1594240425613", //self.clientID,
          eventId: "E1637823584078",
        },
        data: {
          EventFullName: "Test Event DG " + new Date().toString(),
          EventShortName: "Test Event DG " + new Date().toString(),
          EventStartDate: "2021-12-01T00:00:00.000Z",
          EventEndDate: "2021-12-09T00:00:00.000Z",
          TimeZone: "Asia/Calcutta",
        },
      };
      axios
        .post(APIs.CloneEvent, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          debugger
          // self.IsSubmitting = false;
          // if (response.data.status == 0) {
          //   this.showVerificationLinkSentMessage = true;
          // }

          console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          debugger
          //self.IsSubmitting = false;
          console.log("Error:" + error);
        });

      // let config = {
      // 	method: 'post',
      // 	url: 'https://us-central1-e2monair.cloudfunctions.net/e2monair-prd-clone-event',
      // 	headers: {
      // 		'Authorization': 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTYwNDQwMjU5NCwiZXhwIjoxNjA0NDA2MTk0LCJpc3MiOiJzZXJ2ZXJsZXNzLWZyYW1ld29ya0B1YXRlMm1vbmFpci5pYW0uZ3NlcnZpY2VhY2NvdW50LmNvbSIsInN1YiI6InNlcnZlcmxlc3MtZnJhbWV3b3JrQHVhdGUybW9uYWlyLmlhbS5nc2VydmljZWFjY291bnQuY29tIiwidWlkIjoiMTkxMDAyIiwiY2xhaW1zIjp7InJvbGVzIjpbMTAsMTFdfX0.OJrpkrkLjhVzOD1TLy3ML1MrbxHDLFPIgXSCnxbyHXM1_qXesVSWdby3CSknrEUrO9OXOkJTnW9iJ961peJVGLmZs8gPx5gP_0jE1W-kYRg4QAjVQqjTmA3eOwW9MwiX3W_FrL9fV8WvtgIJqn-WhL1amZQX1b3Hz15bIkBNzZykFlGM14PSR-32I_LAtPOMr2Iu2nMHdkOYFuE63XWHidbxtuT6CBxePd02kICzixwF0cgeqkHjWf8ZHuME7H6KRzOy4z0uxzWx_YFHw-hdJX4VNGJHosXczBYhJlUtl2fEjEdMFkQIqJ2l9IHQ7UibFUhLbjswuli3YHXJ8X31MQ',
      // 		'Content-Type': 'application/json'
      // 	},
      // 	data : data
      // };

      // axios(config)
      // .then((response) => {
      // 	console.log(JSON.stringify(response.data));
      // })
      // .catch((error) => {
      // 	console.log(error);
      // });
    },
    Logout() {
      bus.$emit("clearState", true);
      setTimeout(() => {
        self.uid = self.getSessionUserId();
        //location.reload();
      }, 1000);
    },

    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    createTimer() {
      if (timer) {
        clearInterval(timer);
      }
      axios
        .get(APIs.ServerTimeApi)
        .then((responseData) => {
          var serverTime = new Date(
            responseData.data.data.year,
            responseData.data.data.month - 1,
            responseData.data.data.day,
            responseData.data.data.hour,
            responseData.data.data.min,
            responseData.data.data.sec,
            0
          );
          var offset = serverTime.getTimezoneOffset();
          var clientTime = serverTime.getTime() + offset * -1 * 60000;
          //console.log(serverTime);
          var dtNow = new Date();
          self.systemTimeDiff = parseInt((dtNow.getTime() - clientTime) / 1000);
          //console.log("systemTimeDiff: " + self.systemTimeDiff);
          self.currentTimeS = self.currentTime(self.systemTimeDiff);
          timer = setInterval(function () {
            self.currentTimeS++;
          }, 1000);
        })
        .catch(function (err) {
          self.currentTimeS = parseInt(new Date().getTime() / 1000);
          timer = setInterval(function () {
            self.currentTimeS++;
          }, 1000);
          console.log("getservertime:" + err);
        });
    },
    stopShimmer() {
      $(".shimmer-effect").css("display", "none");
    },
    mob_elist_search() {
      $("#mob_ev_search").css("display", "block");
      $(".mob_search_button").css("opacity", "0 ");
    },
   
    AddToGoogleCalendar(event) {
      var dtFrom = this.getCalendarDateTime(
        event.EventStartDate.seconds,
        "google"
      );
      var dtTo = this.getCalendarDateTime(event.EventEndDate.seconds, "google");
      //alert(location.host.toLowerCase());
      return (
        "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
        dtFrom +
        "/" +
        dtTo +
        "&text=" +
        event.Name +
        "&details=" +
        event.Name.replace("&", "and") +
        "<br/>To Login Go To " +
        location.origin.toLowerCase()
      );
      //return (
      //  "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
      //  dtFrom +
      //  "/" +
      //  dtTo +
      //  "&text=" +
      //  this.Title +
      //  "&details=" +
      //  this.DescriptionShort.replace("&", "and") +
      //  "<br /><br />To Login <a href='" +
      //  location.origin.toLowerCase() +
      //  "'>Click Here</a>" +
      //  "&location=" +
      //  this.Location
      //);
    },
    AddToCalendar(event, service) {
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var dtFrom = this.getCalendarDateTime(
        event.EventStartDate.seconds,
        service
      );
      var dtTo = this.getCalendarDateTime(event.EventEndDate.seconds, service);
      let body =
        event.Name + "<br/>To Login Go To " + location.origin.toLowerCase();
      var linkUrl =
        "start=" +
        dtFrom +
        "&end=" +
        dtTo +
        "&title=" +
        event.Name +
        "&description=" +
        body +
        "&location=&timezone=" +
        tz.replace("/", "%2F") +
        "&service=" +
        service;
      linkUrl =
        "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&" +
        linkUrl;
      return linkUrl;
    },
    ClearFilter() {
      self.filterDateFrom = "";
      self.filterDateTo = "";
      self.filterRegion = "";
      self.filterType = "";
      self.advancedSearch = false;
    },
    displayEvents() {
      this.pageIndex++;
      var cnt = 0;
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");
      listRef
        //.where("IsPublished", "==", true)
        .where("EventTypeId", "==", 2)
        .where("AllowRegistration", "==", true)
        //.get()
        .onSnapshot((querySnapshot) => {
          this.EventsData = [];
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              cnt++;
              var data = doc.data();
              /* this.EventsData.push({
                id: doc.id,
                Name: data.EventFullName,
                EventLogo: data.EventLogo,
                EventStartDate: data.EventStartDate,
                EventEndDate: data.EventEndDate,
                EventCollectionName: data.EventCollectionName,
                EventTypeId: data.EventTypeId,
                EventTimezone: data.TimeZone,
                EventStartDateString: self.formatDate(data.EventStartDate),
                EventEndDateString: self.formatDate(data.EventEndDate)
              });*/
              var obj = new Object();
              obj.id = doc.id;
              obj.Name = data.EventFullName;
              obj.IsPublished = data.IsPublished;
              obj.EventLogo = data.EventLogo;
              // obj.EventStartDate = data.EventStartDate;
              // obj.EventEndDate = data.EventEndDate;
              obj.EventCollectionName = data.EventCollectionName;
              obj.EventTypeId = data.EventTypeId;
              obj.EventTimezone = moment.tz.guess(); //data.TimeZone;
              obj.Timezone = data.TimeZone;
              //-------------------------------------------------------------------------------------------
              /* var mZone = moment.tz.guess();
              //obj.EventStartDateString = self.formatDate(data.EventStartDate);
              if (data.TimeZone != mZone) {
                var EventStartDate = self.formatDateTimeZoneWise(
                  data.EventStartDate
                );
                var momnt = moment.tz(EventStartDate, data.TimeZone);
                var strtDate = momnt.clone().tz(moment.tz.guess());
                obj.EventStartDateString = self.GetActualDateFormat(
                  strtDate.format()
                );
              } else {
                obj.EventStartDateString = self.formatDate(data.EventStartDate);
              }*/
              var dateFormat = require("dateformat");

              var dtstrt = new Date(data.EventStartDate.seconds * 1000);
              obj.EventStartDateString = dateFormat(
                dtstrt,
                "mmm dd, yyyy hh:MM TT"
              );
              // obj.EventStartDateString = moment(dtstrt).format(
              //   " MMMM Do, h:mm a"
              // );
              //self.formatDate(data.EventStartDate);
              //------------------------------------------------------------------------------------------------
              /*if (data.TimeZone != mZone) {
                // obj.EventEndDateString = self.formatDate(data.EventEndDate);
                var EventEndDate = self.formatDateTimeZoneWise(
                  data.EventEndDate
                );
                var momnt2 = moment.tz(EventEndDate, data.TimeZone);
                var endDate = momnt2.clone().tz(moment.tz.guess());
                obj.EventEndDateString = self.GetActualDateFormat(
                  endDate.format()
                );
              } else {
                obj.EventEndDateString = self.formatDate(data.EventEndDate);
              }*/
              var dtend = new Date(data.EventEndDate.seconds * 1000);
              obj.EventEndDateString = dateFormat(
                dtend,
                "mmm dd, yyyy hh:MM TT"
              ); // self.formatDate(data.EventEndDate);
              obj.EventStartDate = data.EventStartDate;
              obj.EventEndDate = data.EventEndDate;
              //------------------------------------------------------------------------------------------------
              self.EventsData.push(obj);
            });
            self.noEventMessage = self.EventsData.length > 0 ? false : true;
            // self.EventsData = self.EventsData.sort(function compare(a, b) {
            //   //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
            //   // var dateA = parseInt(
            //   //   new Date(a.EventStartDate.seconds * 1000).getTime() / 1000
            //   // );
            //   // var dateB = parseInt(
            //   //   new Date(b.EventStartDate.seconds * 1000).getTime() / 1000
            //   // );
            //   return b.EventStartDate.seconds - a.EventStartDate.seconds;
            // });
            if (cnt == 1) {
              //router.push({
              //  path:
              //    "/event/" +
              //    this.EventsData[0].id +
              //    "/" +
              //    this.EventsData[0].Name
              //});
              router.push({
                path: "/event/" + this.EventsData[0].id,
              });
            }
          } else {
            self.noEventMessage = true;
          }
          self.EventsLoaded = true;
        });
      // .catch(error => {
      //   alert(error);
      //   // console.log("Error getting documents: ", error);
      // });
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    selectEvent: function (eventId, evntName) {
      console.log("evntName:--- " + evntName);
      router.push({
        path: "/eventv3/" + eventId,
      });
    },
    formatDate: function (seconds) {
      var dateString = "";
      //  alert(seconds);
      // if (seconds == 1594125120) {
      //   debugger;
      // }
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    getCalendarDateTime: function (s, option) {
      var dt = new Date(s * 1000);
      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();
      if (month < 10) {
        month = "0" + month.toString();
      }
      if (day < 10) {
        day = "0" + day.toString();
      }
      var hours = dt.getHours();
      if (hours < 10) {
        hours = "0" + hours.toString();
      }
      var minutes = dt.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes.toString();
      }
      var seconds = dt.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds.toString();
      }
      //var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      //hours = hours > 12 ? hours - 12 : hours;
      //hours = hours == 0 ? 12 : hours;
      //minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      //seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
      var formattedValue = "";
      if (option == "google") {
        formattedValue =
          year.toString() +
          month.toString() +
          day.toString() +
          "T" +
          hours.toString() +
          minutes.toString() +
          seconds.toString();
      } else {
        //formattedValue =
        //  year.toString() +
        //  "-" +
        //  month.toString() +
        //  "-" +
        //  day.toString() +
        //  "T" +
        //  hours.toString() +
        //  ":" +
        //  minutes.toString() +
        //  ":" +
        //  seconds.toString();
        //12%2F18%2F2020+11%3A00+AM
        //alert(hours);
        //alert(minutes);
        formattedValue =
          year.toString() +
          "%2F" +
          month.toString() +
          "%2F" +
          day.toString() +
          "+";

        if (hours < 10) {
          formattedValue += hours.toString() + "%3A";
        } else {
          if (hours <= 12) {
            formattedValue += hours.toString() + "%3A";
          } else {
            formattedValue += (hours - 12).toString() + "%3A";
          }
        }

        if (minutes < 10) {
          formattedValue += minutes.toString() + "+";
        } else {
          formattedValue += minutes.toString() + "+";
        }

        if (hours < 12) {
          formattedValue += "AM";
        } else {
          formattedValue += "PM";
        }
        //"+" +
        //  "10" + //hours.toString() +
        //  "%3A" +
        //  "10+AM"; //minutes.toString();
        //alert(formattedValue);
      }
      return formattedValue;
    },
    /* ,
    computed: {
      BannerURL() {
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // return obj.branding[0].banner;
        //  db.collection("OA_UAT")
        //         .doc("ClientList")
        //         .collection("Clients")
        //         .where("CustomDomain", "==", this.result)
        //         .get()
        //         .then(querySnapshot => {
        //           querySnapshot.forEach(doc => {
        //           });
        //         });
      },
      pageBg() {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.EventBranding[0].bg2;
      }
    }*/
  },
};
</script>
<style>
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>
